"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var OutboxFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_OutboxFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.646 3.854a.5.5 0 0 1 0-.707l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.707L8.5 1.707V7a.5.5 0 0 1-1 0V1.707L5.354 3.854a.5.5 0 0 1-.708 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 4.5H3.554a1.5 1.5 0 0 0-1.272.705L.222 8.5H5A1.5 1.5 0 0 1 6.5 10a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5A1.5 1.5 0 0 1 11 8.5h4.777l-2.06-3.295a1.5 1.5 0 0 0-1.271-.705H9.5V7a1.5 1.5 0 1 1-3 0V4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.5v-5h5a.5.5 0 0 1 .5.5A1.5 1.5 0 0 0 7 11.5h2a1.5 1.5 0 0 0 1.5-1.5.5.5 0 0 1 .5-.5h5v5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_OutboxFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = OutboxFill;
exports["default"] = _default;